<template>
  <div>
    <div style="display: flex; align-items: flex-start;">
      <representative-task-list/>
    </div>
  </div>
</template>

<script>
import RepresentativeTaskList from '../../components/reports/representativeTask/List';

export default {
  components: {
    RepresentativeTaskList,
  },
  data() {
    return {

    }
  },
  computed: {

  },
  async mounted() {
    this.loading = true;
    this.loading = false;
  },
  methods: {

  }
};
</script>

<style lang="scss">
  .filter-container {
    padding: 20px;
    margin: -20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #EBEEF5;
  }
</style>
